import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

const TONES: Record<Tone, string> = {
  neutral: 'bg-faint text-muted ring-1 ring-inset ring-border',
  primary: 'bg-primary/10 text-primary ring-1 ring-inset ring-primary/15',
  success: 'bg-primary/10 text-primary ring-1 ring-inset ring-primary/15',
  warning: 'bg-clay-500/12 text-clay-600 ring-1 ring-inset ring-clay-500/20',
  danger: 'bg-danger/10 text-danger ring-1 ring-inset ring-danger/15',
  info: 'bg-info/10 text-info ring-1 ring-inset ring-info/15',
};

export type BadgeProps = {
  tone?: Tone;
  className?: string;
  children: ReactNode;
};

export function Badge({ tone = 'neutral', className, children }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[0.72rem] font-medium tracking-tight',
        TONES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
